export default __webpack_public_path__ + "static/media/CNo.92-0.ec2ba63f.jpg";